require([
    'services',
    'jquery',
    'ch_selectors',
    'ch_load_mask',
    'ch_semantic_responsive',
    'ch_form_validation',
    'ch_scrollto',
    'google_captcha'
], function () {
    $(function () {
        $._('scroll_action').on('click', function (e) {
            e.preventDefault();

            var benefits_section = $._('benefits_section').offset().top - 100;
            var how_section = $._('how_section').offset().top - 80;
            var form_section = $._('form_section').offset().top - 140;
            var type = $(this).data('type');
            var scroll_destination;

            if (type === 'benefits') {
                scroll_destination = benefits_section;
            } else if (type === 'how') {
                scroll_destination = how_section;
            } else if (type === 'signup') {
                scroll_destination = form_section;
            }

            CH.scrollTo(scroll_destination);
        });

        // @todo - this page is still not all "new semantic" but the form *is* using new semantic styles, so we must validate it as such
        CH.semantic_form_validation = true;

        CH.validate('form_CorporateSignup');

        // if (typeof $.fn.cycle !== 'undefined') {
        //     var slideshow_background = $._('slideshow_background');
        //     var slideshow_overlay = $._('slideshow_overlay');
        //
        //     slideshow_background.cycle({
        //         slides: 'div.background_slide',
        //         autoHeight: false,
        //         pager: '[data-js="slideshow_background_pager"]',
        //         log: false,
        //     });
        //     slideshow_overlay.cycle({
        //         slides: 'div.overlay_slide',
        //         autoHeight: false,
        //         log: false,
        //     });
        //
        //     // When you click on the pager of the background slideshow it tells the overlay slideshow which slide to go to
        //     $._('slideshow_background_pager').find('a').on('click', function () {
        //         slideshow_overlay.cycle('goto', $(this).index());
        //     });
        // }
    });
});
